export default "__VITE_ASSET__36ce80d7__"